import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateTimeLogMutationVariables = Types.Exact<{
  data: Types.UpdateTimeLogInput;
}>;


export type UpdateTimeLogMutation = { updateTimeLog: { success: boolean, updatedEntitiesTimeSpent?: Array<{ entityId: string, entityType: Types.TimeLogEntityTypeEnum, parentEntityId?: string | null, parentEntityType?: Types.TimeLogEntityTypeEnum | null, totalTimeSpent?: number | null, selfTimeSpent?: number | null }> | null } };


export const UpdateTimeLogDocument = /*#__PURE__*/ gql`
    mutation updateTimeLog($data: UpdateTimeLogInput!) {
  updateTimeLog(data: $data) {
    success
    updatedEntitiesTimeSpent {
      entityId
      entityType
      parentEntityId
      parentEntityType
      totalTimeSpent
      selfTimeSpent
    }
  }
}
    `;

export function useUpdateTimeLogMutation() {
  return Urql.useMutation<UpdateTimeLogMutation, UpdateTimeLogMutationVariables>(UpdateTimeLogDocument);
};